import { ApplicationWithDetails } from '../../../types';
import { iSpringInstruction } from './iSpringInstruction';

export const iSpring: ApplicationWithDetails = {
	id: `11EE4351F01FFBBEA55A4652C9FA8BC6`,
	name: `Dodo Learning. Интеграция`,
	description: `Незаменимый помощник в обучении сотрудников.`,
	descriptionLong: `Dodo Learning \u2013 это незаменимый помощник в обучении сотрудников, который всегда под рукой. 
Платформа помогает упростить процесс обучения сотрудников, сделать его более наглядным, интересным и увлекательным. Включает в себя интерактивные курсы, программы обучения, информацию о важных изменениях и главных новостях в обучении.\n\nЧтобы сотрудники могли начать обучение, подключите свои подразделения к платформе Dodo Learning.`,
	logoUrl: `https://cdn.dodostatic.net/static/marketplace/ispring/logo-1`,
	sliders: [
		// eslint-disable-next-line sonarjs/no-duplicate-string
		`https://cdn.dodostatic.net/static/marketplace/ispring/slider-1-fixed`,
		`https://cdn.dodostatic.net/static/marketplace/ispring/slider-2`,
		`https://cdn.dodostatic.net/static/marketplace/ispring/slider-3`,
		`https://cdn.dodostatic.net/static/marketplace/ispring/slider-4`,
		`https://cdn.dodostatic.net/static/marketplace/ispring/slider-5`,
	],
	logoBgr: `https://cdn.dodostatic.net/static/marketplace/ispring/logo-bgr`,
	conceptions: [`Dodo Pizza`, `Drinkit`, `Doner42`],
	webSiteUrl: `https://www.ispring.ru/`,
	supportUrl: null,
	redirectUrl: `https://dodois.effit.ru/partners/sign-in`,
	contactEmail: `podorojnik@dodois.io`,
	supportEmail: ``,
	type: `Web`,
	categories: [`Сотрудники`, `Обучение`, `Развитие`],
	countries: [`Россия`, `Казахстан`, `Беларусь`],
	languages: [`Русский`, `English`],
	price: `Бесплатно`,
	version: `1.0`,
	developer: `ООО «Ричмедиа»`,
	plans: null,
	instructions: iSpringInstruction,
	details: null,
	knowledgeBase: null,
	isExternal: true,
	showInstruction: false,
	versionHistory: null,
	goToApp: true,
};
